<div class="pt-10 px-10 pb-10">
  <div class="flex justify-between mb-4">
    <div class="flex justify-between items-center">
      <h1 class="text-2xl font-bold">{{roleId ? "Atualizar" : "Novo"}} Cargo</h1>
    </div>
    <div class="flex" *ngxPermissionsOnly="['Roles.Delete']">
      <button class="button-compact button-color-gray w-full px-4" (click)="onDelete()">
        <i class="fa-solid fa-trash mr-2"></i>
        Deletar
      </button>
    </div>
  </div>

  <div class="bg-white shadow rounded-lg p-4 mb-4">
    <div class="flex flex-col">
      <span class="text-sm mb-2">Nome do Cargo</span>
      <input type="text" placeholder="Insira o nome do cargo"
        class="w-full p-2 border border-gray-200 rounded-lg input-field-focus" [(ngModel)]="role.name" />
    </div>
  </div>

  <div class="grid grid-cols-1 xl:grid-cols-2 gap-4">
    <div *ngFor="let category of categories" class="bg-white shadow rounded-lg p-4">
      <div class="mb-3">
        <label class="flex items-center font-medium">
          <input type="checkbox" class="mr-2" [checked]="areAllPermissionsInCategorySelected(category)"
            (change)="toggleAllInCategory(category)" />
          {{category}}
        </label>
      </div>
      <div class="pl-6 grid grid-cols-2 gap-x-4">
        <ng-container *ngFor="let permission of permissionsByCategory[category]; let i = index">
          <div class="mb-2">
            <label class="flex items-center text-sm">
              <input type="checkbox" class="mr-2" [checked]="isPermissionSelected(permission)"
                (change)="togglePermission(permission)" />
              <span class="truncate" [title]="permission.displayName">{{permission.displayName}}</span>
            </label>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="flex w-full justify-end mt-5">
    <div class="flex gap-x-3 w-[400px]">
      <button class="button-compact button-color-gray w-full" (click)="close()">
        Cancelar
      </button>
      <button class="button-compact w-full" (click)="onSubmit()"
        [disabled]="!(role.name && role.permissionsIds.length > 0)" [ngClass]="{
            'button-color-primary': role.name && role.permissionsIds.length > 0,
            'button-disabled': !(role.name && role.permissionsIds.length > 0)
          }" matTooltip="{{ getTooltipErrorMessage() }}">
        Salvar Cargo
      </button>
    </div>
  </div>
</div>